import Ajax from '../js/common/ajax';

export default {
    // 销项发票
    output: {
        list(params = {}) { return Ajax.get('/invoice-output', params); },
        load(id) { return Ajax.get(`/invoice-output/${id}`); },
        delete(id) { return Ajax.delete(`/invoice-output/${id}`); },
        save(params = {}) { return Ajax.post('/invoice-output', params); },
        update(params = {}) { return Ajax.put('/invoice-output', params); },
        options() { return Ajax.get('/invoice-output/options'); },
        generateVoucher(ids) { return Ajax.post('/invoice-output/generate-voucher', ids); },
        importData(formData) { return Ajax.post('/invoice-output/import', formData); }
    },
    // 进项发票
    income: {
        list(params = {}) { return Ajax.get('/invoice-income', params); },
        load(id) { return Ajax.get(`/invoice-income/${id}`); },
        delete(id) { return Ajax.delete(`/invoice-income/${id}`); },
        save(params = {}) { return Ajax.post('/invoice-income', params); },
        update(params = {}) { return Ajax.put('/invoice-income', params); },
        options() { return Ajax.get('/invoice-income/options'); },
        generateVoucher(ids) { return Ajax.post('/invoice-income/generate-voucher', ids); },
        importData(formData) { return Ajax.post('/invoice-income/import', formData); }
    },
    // 费用单据
    expense: {
        list(params = {}) { return Ajax.get('/invoice-expense', params); },
        load(id) { return Ajax.get(`/invoice-expense/${id}`); },
        delete(id) { return Ajax.delete(`/invoice-expense/${id}`); },
        save(params = {}) { return Ajax.post('/invoice-expense', params); },
        update(params = {}) { return Ajax.put('/invoice-expense', params); },
        options() { return Ajax.get('/invoice-expense/options'); },
        generateVoucher(ids) { return Ajax.post('/invoice-expense/generate-voucher', ids); },
        importData(formData) { return Ajax.post('/invoice-expense/import', formData); }
    },
    // 无票收入
    nonIncome: {
        list(params = {}) { return Ajax.get('/invoice-non-income', params); },
        load(id) { return Ajax.get(`/invoice-non-income/${id}`); },
        delete(id) { return Ajax.delete(`/invoice-non-income/${id}`); },
        save(params = {}) { return Ajax.post('/invoice-non-income', params); },
        update(params = {}) { return Ajax.put('/invoice-non-income', params); },
        options() { return Ajax.get('/invoice-non-income/options'); },
        generateVoucher(ids) { return Ajax.post('/invoice-non-income/generate-voucher', ids); },
        importData(formData) { return Ajax.post('/invoice-non-income/import', formData); }
    },
    // 智能开票
    smart: {
        list(params = {}) { return Ajax.get('/invoice-smart', params); },
        load(id) { return Ajax.get(`/invoice-smart/${id}`); },
        delete(id) { return Ajax.delete(`/invoice-smart/${id}`); },
        save(params = {}) { return Ajax.post('/invoice-smart', params); },
        update(params = {}) { return Ajax.put('/invoice-smart', params); },
        issue(id) { return Ajax.post(`/invoice-smart/${id}/issue`); },
        options() { return Ajax.get('/invoice-smart/options'); },
        configs(configType) { return Ajax.get('/invoice-smart/configs', { configType }); },
        saveConfig(config) { return Ajax.post('/invoice-smart/configs', config); },
        deleteConfig(id) { return Ajax.delete(`/invoice-smart/configs/${id}`); }
    }
};
